import "./accordion.css.js";
const c = {
  accordion: "pf-v6-c-accordion",
  accordionExpandableContent: "pf-v6-c-accordion__expandable-content",
  accordionExpandableContentBody: "pf-v6-c-accordion__expandable-content-body",
  accordionItem: "pf-v6-c-accordion__item",
  accordionToggle: "pf-v6-c-accordion__toggle",
  accordionToggleIcon: "pf-v6-c-accordion__toggle-icon",
  accordionToggleText: "pf-v6-c-accordion__toggle-text",
  dirRtl: "pf-v6-m-dir-rtl",
  modifiers: {
    toggleStart: "pf-m-toggle-start",
    displayLg: "pf-m-display-lg",
    bordered: "pf-m-bordered",
    expanded: "pf-m-expanded",
    fixed: "pf-m-fixed"
  }
};
export {
  c as default
};
